import React from 'react'

const Modal = ({ isOpen, onClose, children, modalTitle = "" }) => {
  if (!isOpen) return null // Modal kapanmışsa render edilmez
  const handleBackdropClick = (e) => {
    // Modal dışına tıklanırsa onClose fonksiyonu çalıştırılır
    if (e.target === e.currentTarget) {
      onClose();
    }
  };
  return (
    <div
      className='modal fade show'
      tabIndex={-1}
      style={{
        display: 'block',

        zIndex: 1050, // Bootstrap modal z-index değeri
      }}
      onClick={handleBackdropClick}
      aria-hidden='true'
    >
      <div className='modal-dialog' style={{
        margin: 0,
        left: '50%',
        minWidth: 'fit-content',
        top: '50%',
        transform: 'translate(-50%, -50%)',
      }}>
        <div className='modal-content'>
          <div className='modal-header py-3' style={{
            border: 'none'
          }}>
            {/* <h5 className='modal-title'>{modalTitle}</h5> */}
            <button
              type='button'
              className='btn-close'
              data-bs-dismiss='modal'
              aria-label='Close'
              onClick={onClose}
            ></button>
          </div>
          <div className='modal-body' style={{
            padding : '5px 15px'
          }}>{children}</div>
          <div className='modal-footer p-0'>

          </div>
        </div>
      </div>
    </div>
  )
}

export default Modal
